import { Buffer } from 'buffer';

export const removeEmptyValuesFromArray = (arr: Array<unknown>) => {
  if (arr && arr.length > 0) {
    return arr.filter((item) => item !== undefined && item !== null && item !== '');
  }

  return arr;
};

export const isObjectEmpty = (obj: Record<string, unknown>) => {
  return Object.keys(obj).length === 0;
};

export const areWidgetsRendered = (widgetIds: string[]) => {
  return widgetIds.every((widgetId) => isVisible(widgetId));

  function isVisible(dataId: string) {
    const el = document.querySelector(`[data-id="${dataId}"]`);
    // in current implementation every widget have shadow root
    // however, if the element is not rendered yet -> child elements will be only its styles
    // this logic is not perfect, because it can be false positive
    const elShadowRoot = el?.shadowRoot;
    const elShadowRootChildrens = elShadowRoot?.childNodes ? [...elShadowRoot.childNodes] : [];
    const elShadowRootIsDivChildren = elShadowRootChildrens.some((child) => child?.nodeName === 'DIV');

    return elShadowRootIsDivChildren;
  }
};

export const isInStorybook = () => {
  return window.location.pathname.includes('/iframe.html');
};

export const encodeBase64 = (data: string) => {
  return Buffer.from(data).toString('base64');
};
